"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialNetworkTypeList = exports.socialSeparators = exports.socialTypes = exports.socialChoices = exports.socialNetworkInputProperties = exports.SocialNetworksURLs = exports.socialNetworkNames = void 0;
exports.socialNetworkNames = {
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "Linkedin",
};
exports.SocialNetworksURLs = {
    facebook: "https://www.facebook.com",
    instagram: "https://www.instagram.com",
    twitter: "https://twitter.com",
    linkedin: "https://linkedin.com/in",
};
exports.socialNetworkInputProperties = {
    facebook: {
        name: "facebook",
        color: "#3b5998",
        caption: exports.socialNetworkNames.facebook,
        prefix: "facebook.com/",
        regexp: "https:\\/\\/(?:\\w{2,3}\\.)?facebook.com\\/(.+)|(\\w+)\\s?\\(f.*\\)|(\\w+):facebook",
        template: "https://www.facebook.com/_value_",
        dataKey: "facebook_username",
        choiceValue: 1,
    },
    twitter: {
        name: "twitter",
        color: "#00AADE",
        caption: exports.socialNetworkNames.twitter,
        prefix: "@",
        regexp: "https:\\/\\/twitter\\.com\\/(.+)|(\\w+)\\s?\\(t.*\\)|(\\w+):twitter",
        template: "https://twitter.com/_value_",
        dataKey: "twitter_username",
        choiceValue: 2,
    },
    instagram: {
        name: "instagram",
        color: "#f17667",
        caption: exports.socialNetworkNames.instagram,
        prefix: "username",
        regexp: "https:\\/\\/(?:\\w{2,3}\\.)?instagram\\.com\\/(.+)|(\\w+)\\s?\\(i.*\\)|(\\w+):instagram",
        template: "https://www.instagram.com/_value_",
        dataKey: "instagram_username",
        choiceValue: 3,
    },
    linkedin: {
        name: "linkedin",
        color: "#007fb5",
        caption: exports.socialNetworkNames.linkedin,
        prefix: "linkedin.com/in/",
        regexp: "https:\\/\\/(?:\\w{2,3}\\.)?linkedin\\.com\\/in\\/(.+)|(\\w+)\\s?\\(l.*\\)|(\\w+):linkedin",
        template: "https://linkedin.com/in/_value_",
        dataKey: "linkedin_username",
        choiceValue: 4,
    },
};
exports.socialChoices = {
    facebook: "1",
    twitter: "2",
    instagram: "3",
    linkedin: "4",
};
exports.socialTypes = {
    1: "facebook",
    2: "twitter",
    3: "instagram",
    4: "linkedin",
};
exports.socialSeparators = ";,|";
exports.socialNetworkTypeList = [
    "facebook",
    "twitter",
    "linkedin",
    "instagram",
];
